"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/09/18
 */
Object.defineProperty(exports, "__esModule", { value: true });
const port_1 = require("../messages/port");
const receive_1 = require("../messages/receive");
const version_json_1 = require("../version.json");
function prepareData(action, value) {
    const baseMessage = {
        action,
        namespace: "system",
    };
    if (value) {
        return {
            type: "request",
            message: Object.assign(Object.assign({}, baseMessage), { value }),
        };
    }
    else {
        return {
            type: "request",
            message: baseMessage,
        };
    }
}
const system = {
    initialise: ({ appName, appVersion, vendor, onMessage }) => {
        const listenerSet = (0, receive_1.setOnMessage)(onMessage);
        if (listenerSet) {
            const message = { appName, appVersion, vendor, partnerSdkVersion: version_json_1.version };
            const data = prepareData("initialise", message);
            (0, port_1.sendMessage)(data);
        }
    },
    sendMessage: (message) => {
        (0, port_1.sendMessage)(message);
    },
    getContext: () => {
        const data = prepareData("getContext");
        (0, port_1.sendMessage)(data);
    },
    getLocale: () => {
        const data = prepareData("getLocale");
        (0, port_1.sendMessage)(data);
    },
    getTheme: () => {
        const data = prepareData("getTheme");
        (0, port_1.sendMessage)(data);
    },
    getVersion: () => {
        const data = prepareData("getVersion", version_json_1.version);
        (0, port_1.sendMessage)(data);
    },
    getEvents: () => {
        const data = prepareData("getEvents");
        (0, port_1.sendMessage)(data);
    },
    sendEvent: (name, data) => {
        const eventData = prepareData("sendEvent", { name, data });
        (0, port_1.sendMessage)(eventData);
    },
};
exports.default = system;
//# sourceMappingURL=system.js.map